import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { active, EDButton, EDTypography, EEDAnimation, grey, spacing } from "@trailblazer-game/ed-webkit";
import Box from "@mui/material/Box";
import { useParallax } from "react-scroll-parallax";
import { IWithLazyLoadProps, withLazyLoad } from "../../../../hooks/withLazyLoad";
import { forwardRef, memo } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { EPage } from "../../../../helpers/constants";
import useMediaQuery from "@mui/material/useMediaQuery";
import { theme } from "../../../Theme/Theme";

interface IHomePlayNowProps extends IWithLazyLoadProps {
  className?: string;
}

const HomePlayNow = memo(forwardRef(({ className }: IHomePlayNowProps, ref) => {
  const isMedium = useMediaQuery(theme.breakpoints.down("md"));

  const { ref: backgroundRef } = useParallax<HTMLDivElement>({
    speed: 10,
    translateY: [ 0, -25, "easeInCirc" ]
  });

  const router = useRouter();

  const handleNavigateToGame = () => {
    router.push(EPage.GAME);
  }

  return <Stack className={className} alignItems={"center"} justifyContent={"flex-start"} spacing={isMedium ? 16 : 48} ref={ref}>
    <Box className={`alpha-logo ${EEDAnimation.FadeIn}`} sx={{position: "relative", zIndex: 10}}>
      <Image src={"/home/ed-logo.webp"} layout={"fill"}/>
    </Box>

    <Stack alignItems={"center"} justifyContent={"center"} spacing={4} sx={{position: "relative", zIndex: 10}}>
      <EDTypography variant={"h1"} sx={{ color: active("primary"), textShadow: `1px 1px 6px black` }} align={"center"}>
        Play Now!
      </EDTypography>
      <EDButton label={"Join the fight"} onClick={handleNavigateToGame}></EDButton>
    </Stack>

    <Box className={`background`} ref={backgroundRef}/>
  </Stack>;
}));

HomePlayNow.displayName = "HomePlayNow";

const HomePlayNowStyled = styled(HomePlayNow)(() => ({
  minHeight: "100vh",
  width: "100%",
  position: "relative",
  overflow: "visible",
  aspectRatio: "1",
  backgroundColor: grey("1000"),
  ".background": {
    position: "absolute",
    left: 0,
    top: 0,
    margin: "0 !important",
    width: "100%",
    height: "100%",
    backgroundImage: "linear-gradient(#686eb4,rgba(255,255,255,0) 15%, rgba(255,255,255,0) 85%, #151515 100%),url(/home/play-now-bg.webp)",
    backgroundSize: "auto,105%",
    backgroundPosition: "0 0,57% 100%",
    backgroundRepeat: "no-repeat"
  },
  ".alpha-logo": {
    position: "relative",
    width: "100%",
    maxWidth: "800px",
    aspectRatio: "1.864"
  },
  [theme.breakpoints.down("md")]: {
    ".background": {
      backgroundPosition: "0 0,center",
      backgroundSize: "auto,cover",
    }
  }
}));

// Export
export default withLazyLoad(HomePlayNowStyled);